import * as React from 'react';
import styled from 'styled-components';
import UnorderedList from '@govuk-react/unordered-list';
import { NTA_LIGHT } from '@govuk-react/constants';
import { spacing } from '@govuk-react/lib';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["from", "partOf", "other"];
var StyledContainer = styled('div').withConfig({
  displayName: "src__StyledContainer",
  componentId: "sc-1cttr5m-0"
})({
  fontFamily: NTA_LIGHT
}, spacing.withWhiteSpace());
var StyledDefinition = styled('li').withConfig({
  displayName: "src__StyledDefinition",
  componentId: "sc-1cttr5m-1"
})({
  fontSize: '24px',
  fontWeight: 700,
  lineHeight: 1.25,
  '> a': {
    textDecoration: 'none'
  }
});
/**
 * An ordered list of documents including a document type, when updated and a link.
 *
 * - https://govuk-react.github.io/govuk-react/?path=/docs/document-footer-metadata
 * - https://components.publishing.service.gov.uk/component-guide/document_list
 */

var DocumentFooterMetadata = function DocumentFooterMetadata(_ref) {
  var _ref$from = _ref.from,
      from = _ref$from === void 0 ? undefined : _ref$from,
      _ref$partOf = _ref.partOf,
      partOf = _ref$partOf === void 0 ? undefined : _ref$partOf,
      _ref$other = _ref.other,
      other = _ref$other === void 0 ? undefined : _ref$other,
      props = _objectWithoutProperties(_ref, _excluded);

  var fromData = /*#__PURE__*/React.createElement(StyledContainer, null, from && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, "From:"), /*#__PURE__*/React.createElement(UnorderedList, {
    listStyleType: "none"
  }, from && from.map(function (child, i) {
    return (
      /*#__PURE__*/

      /* eslint-disable react/no-array-index-key */
      React.createElement(StyledDefinition, {
        key: i
      }, child)
      /* eslint-enable react/no-array-index-key */

    );
  }))));
  var partOfData = /*#__PURE__*/React.createElement(StyledContainer, null, partOf && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, "Part of:"), /*#__PURE__*/React.createElement(UnorderedList, {
    listStyleType: "none"
  }, Array.isArray(partOf) && React.Children.map(partOf, function (child, i) {
    return /*#__PURE__*/React.createElement(StyledDefinition, null, child);
  }))));
  var otherData = /*#__PURE__*/React.createElement(StyledContainer, null, other && other.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        marginBottom: 0
      }
    }, item.title, ":"), /*#__PURE__*/React.createElement(UnorderedList, {
      listStyleType: "none"
    }, /*#__PURE__*/React.createElement(StyledDefinition, null, item.content)));
  }));
  return /*#__PURE__*/React.createElement(StyledContainer, props, fromData, partOfData, otherData);
};
DocumentFooterMetadata.defaultProps = {
  from: undefined,
  partOf: undefined,
  other: undefined
};
DocumentFooterMetadata.displayName = 'DocumentFooterMetadata';

export { DocumentFooterMetadata, DocumentFooterMetadata as default };
